export default __webpack_public_path__ + "static/setsquare-71d463fc04d4e86199cd852c34818ec3.png";